<app-page-container>
  <div class="card-body p-0">
    <div class="d-flex first-main">
      <div class="img-section" [routerLink]="['/user', userService.userData?.uriLabel]" id="userLink">
        <app-avatar [imageUrl]="userService?.img" [nick]="userService?.userData?.name" size="lg"></app-avatar>
      </div>
      <div class="first-section-main-body">
        <span class="title-font">Dashboard</span>
        <div class="email" *ngIf="userService.userData?.name !== userService.userData?.uriLabel">{{ userService.userData?.name }}</div>
        <div class="default-font">{{ userService.userData?.email }}</div>
      </div>
    </div>
  </div>

  <div class="search-box">
    <div class="justify-content-between">
      <div class="justify-content-start align-items-center">
        <app-input
          id="searchInput"
          [for]="'searchFC'"
          [placeholder]="'Search Projects'"
          type="search"
          [control]="searchFC"
          (keydown.enter)="searchProjects()"
        ></app-input>
        <div class="d-flex total-count" title="Total">
          ({{ totalProjects }}<span class="desktop-content-b ml-1"> Project<span *ngIf="totalProjects !== 1">s</span></span
          >)
        </div>
        <div class="mt-3 ml-2">
          <app-option
            [id]="'publicSwitch'"
            [type]="'toggle'"
            [buttonLabel]="'include public projects'"
            [title]="publicFC.value === true ? 'exclude public projects from the results.' : 'include public projects in the results.'"
            [control]="publicFC"
            [name]="'publicSwitch'"
          ></app-option>
        </div>
      </div>
      <div class="add-button">
        <div id="todayQuizBtn" class="animated-button default-pointer" title="Today's Quiz Question" (click)="openQuizModal()">
          <app-button btnType="secondary-solid" for="quizBtn" [nav]="true">Today's Quiz Question</app-button>
          <svg class="animated-svg" width="200" height="90" viewBox="0 0 150 90" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              stroke="#395A8F"
              stroke-dasharray="700"
              stroke-dashoffset="0"
              d="M167.911 80.5706C142.167 83.1493 88.2701 78.9658 74.3536 75.8891C60.437 72.8013 2.34143 59.7417 0.868428 40.1857C-0.615566 20.6185 38.9686 -0.819006 84.9614 0.929641C130.954 2.68936 168.681 22.7877 170.121 42.045C171.55 61.3022 142.782 80.0725 104.99 87.3659C67.2084 94.6704 -0.340751 79.8401 17.8849 40.4623"
            ></path>
          </svg>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3 dashboard-container-mid">
    <div class="row organizations-details organizations-details-padding d-flex">
      <div class="card mb-3 box-shadow col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
        <div class="row graph-components">
          <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7 col-xl-7 default-pointer" (click)="tableSorter('name')" id="projectHeaderSort">
            <span class="table-header-font"> Project </span>
            <span class="sort-indicator" *ngIf="sortField === 'name'" [class]="columnSort['name'] ? 'transform-180' : 'transform-0'">▾</span>
          </div>
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 align-self-center no-padding-right desktop-header">
            <span class="table-header-font no-wrap">Organization</span>
          </div>
          <div
            class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 default-pointer no-padding-left desktop-header"
            (click)="tableSorter('modified')"
            id="modifiedHeaderSort"
          >
            <span class="table-header-font"> Last Modified </span>
            <span class="sort-indicator" *ngIf="sortField === 'modified'" [class]="columnSort['modified'] ? 'transform-180' : 'transform-0'">▾</span>
          </div>
        </div>
        <div *ngFor="let project of allProjects; let i = index" class="row graph-components graph-components-body">
          <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7 col-xl-7">
            <a class="default-pointer align-self-center" [href]="activateProjectRoute(project)" id="{{ project?.uriLabel }}Link">
              <div class="d-flex align-items-center">
                <div title="{{ project?.name }}" class="line-clamp-1 table-link-font">
                  {{ project?.name }}
                </div>
                <span *ngIf="project?.public" class="public-badge badge-light public-prj-list">Public</span>
              </div>
              <p *ngIf="!project?.public" class="line-clamp-1 table-body-font desktop-content-b" title="{{ project?.description }}">
                {{ project?.description }}
              </p>
              <p
                *ngIf="project?.public"
                class="line-clamp-1 table-body-font multi-lines desktop-content-b"
                title="{{ project?.description }}"
                [innerHTML]="project?.description ?? ''"
              ></p>
            </a>

            <div class="default-font mobile-small">
              <a
                class="d-flex align-self-center align-items-center default-pointer"
                [routerLink]="['/organizations/', project?.organization?.uriLabel]"
                id="{{ project?.organization?.uriLabel }}Link"
              >
                <app-avatar *ngIf="project?.organization" [imageUrl]="project?.organization?.img" [nick]="project?.organization?.name"></app-avatar>
                <template [ngTemplateOutlet]="planExpirationBadge" [ngTemplateOutletContext]="{ $implicit: project?.organization }"></template>
              </a>
            </div>
            <div class="default-font mobile-small" title="Last Modified">
              {{ project?.modified | date: 'MM/dd/yyyy HH:mm:ss' }}
            </div>
          </div>
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 desktop-md">
            <a
              class="default-font d-flex align-self-start default-pointer"
              [routerLink]="['/organizations/', project?.organization?.uriLabel]"
              id="{{ project?.organization?.uriLabel }}Link"
            >
              <app-avatar
                *ngIf="project?.organization"
                [imageUrl]="project?.organization?.img"
                [nick]="project?.organization?.name"
                class="desktop-content"
              ></app-avatar>
              <app-avatar
                *ngIf="project?.organization"
                [imageUrl]="project?.organization?.img"
                [nick]="project?.organization?.name"
                size="lg"
                class="mobile-content"
              ></app-avatar>
              <p class="line-clamp-2 table-body-font align-self-center desktop-content-b" title="{{ project?.organization?.name }}">
                {{ project?.organization?.name }}
                <template [ngTemplateOutlet]="planExpirationBadge" [ngTemplateOutletContext]="{ $implicit: project?.organization }"></template>
              </p>
              <p class="line-clamp-2 table-body-font align-self-center mobile-content" title="{{ project?.organization?.name }}">
                <template [ngTemplateOutlet]="planExpirationBadge" [ngTemplateOutletContext]="{ $implicit: project?.organization }"></template>
              </p>
            </a>
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 no-padding-left desktop-md">
            <span class="default-font" title="Last Modified">{{ project?.modified | date: 'MM/dd/yyyy HH:mm:ss' }}</span>
          </div>
        </div>
        <app-not-found class="not-found-banner" *ngIf="!loading && !isUserContainProject && allProjects && allProjects.length === 0"
          >No projects found</app-not-found
        >
        <div
          class="d-flex align-items-center m-3"
          *ngIf="
            isUserContainProject &&
            getUserPlanStatus() !== 'EXPIRED' &&
            getUserPlanStatus() !== 'EXPIREDWITHORG' &&
            organizationsList &&
            organizationsList.length > 0 &&
            !loading
          "
        >
          <span> To create your first project, <a [routerLink]="['/new-project']" id="firstProjectLink">Click here</a> </span>
        </div>
        <app-table-pagination
          [page]="page"
          [perPage]="perPage"
          [perPageValue]="perPageValue"
          (pageChange)="onPageChange($event)"
          (perPageValueChange)="selectPaginationLimit($event)"
          [collectionSize]="totalPages"
        >
        </app-table-pagination>
      </div>

      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 organization-background no-padding-right">
        <div class="card mb-3 about box-shadow">
          <div class="card-body">
            <iframe
              id="welcomeVideo"
              *ngIf="welcomeVideoUrl"
              class="rounded"
              width="100%"
              height="315"
              [src]="welcomeVideoUrl"
              title="Welcome to TermHub"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            >
            </iframe>
          </div>
        </div>
        <div class="card mb-3 about box-shadow">
          <div class="card-body mostUsedFeatures">
            <div class="default-font bundled-team">
              <div>Commonly Used Features</div>
            </div>
            <li>
              <a class="default-pointer font-weight-bold" [routerLink]="['/terminologies']" id="viewTerminologiesLink">View Terminology Catalog </a>
            </li>
            <li>
              <a class="default-pointer font-weight-bold" [routerLink]="['/mapsets']" id="viewMapsetsLink">View Mapset Catalog </a>
            </li>
            <li>
              <a class="default-pointer font-weight-bold" [routerLink]="['/projects/previewFeaturesProject']" id="newFeaturesLink"
                >Try Preview Features
              </a>
            </li>
            <li>
              <a class="default-pointer font-weight-bold" [routerLink]="['/new-project']" id="newProjectLink">Create a New Project </a>
            </li>
          </div>
        </div>
        <div class="card mb-3 about box-shadow">
          <div class="card-body">
            <div class="d-flex flex-column justify-content-between organizations-details-min-height">
              <div>
                <div class="default-font bundled-team default-pointer">
                  <div [routerLink]="['/organizations/']" id="organizationsLink">
                    Organizations ({{ organizationsList.length }})<span *ngIf="isActiveUserAdmin() === true">
                      ...see <a [routerLink]="['/organizations']">Organizations</a> to include Default</span
                    >
                  </div>
                </div>
                <div class="clearfix d-flex flex-wrap organizations-details-member-avatar">
                  <div
                    *ngIf="
                      getUserPlanStatus() !== 'EXPIRED' &&
                      getUserPlanStatus() !== 'EXPIREDWITHORG' &&
                      !searchProject &&
                      organizationsList &&
                      organizationsList.length === 0 &&
                      !loading
                    "
                  >
                    Start by creating an Organization. <a [routerLink]="['/new-organization']" id="firstOrgLink">Click here</a>
                  </div>
                  <ng-container *ngFor="let organization of organizationsList">
                    <a
                      placement="top"
                      [routerLink]="['/organizations/', organization?.uriLabel]"
                      id="{{ organization?.uriLabel }}ListLink"
                      class="d-flex"
                    >
                      <app-avatar
                        [imageUrl]="orgIcons[organization.id]"
                        [nick]="organization?.name ? organization?.name?.toUpperCase()?.substring(0, 2) : '??'"
                        size="md"
                        [title]="organization?.name + ' ' + getMyRoleInOrganization(organization)"
                      ></app-avatar>
                      <p class="table-body-font line-clamp-1 align-self-center mobile-content">
                        {{ organization?.name + ' ' + getMyRoleInOrganization(organization) }}
                      </p>
                    </a>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <div class="card mb-3 about box-shadow">
          <div class="card-body">
            <div class="d-flex flex-column justify-content-between organizations-details-min-height">
              <div>
                <div class="default-font bundled-team default-pointer">
                  <div class="mb-3" [routerLink]="['/teams']" id="teamsLink">Teams ({{ teamsList.length }})</div>
                </div>
                <div class="clearfix d-flex flex-wrap organizations-details-member-avatar">
                  <div
                    *ngIf="
                      getUserPlanStatus() !== 'EXPIRED' &&
                      getUserPlanStatus() !== 'EXPIREDWITHORG' &&
                      organizationsList &&
                      organizationsList.length === 0 &&
                      !loading
                    "
                  >
                    To create your first team, first create an Organization.
                    <a [routerLink]="['/new-organization']" id="newOrgTeamLink">Click here</a>
                  </div>
                  <div
                    *ngIf="
                      getUserPlanStatus() !== 'EXPIRED' &&
                      organizationsList &&
                      organizationsList.length > 0 &&
                      teamsList &&
                      teamsList.length === 0 &&
                      !loading
                    "
                  >
                    To create your first team, <a [routerLink]="['/new-team']" id="firstTeamLink">Click here</a>
                  </div>
                  <ng-container *ngFor="let team of teamsList">
                    <a placement="top" [routerLink]="[activateTeamRoute(team)]" id="{{ team.uriLabel }}ListLink" class="d-flex">
                      <app-avatar
                        [nick]="team?.name ? team?.name?.toUpperCase()?.substring(0, 2) : '??'"
                        size="md"
                        [title]="team?.name + ' ' + getMyRoleInTeam(team)"
                      ></app-avatar>
                      <p class="table-body-font line-clamp-1 align-self-center mobile-content">{{ team?.name + ' ' + getMyRoleInTeam(team) }}</p></a
                    >
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-page-container>
<ng-template #planExpirationBadge let-params>
  <span
    *ngIf="
      params?.planExpiration &&
      (getTitle(params?.planExpiration, params?.plan) === 'Expired' || getTitle(params?.planExpiration, params?.plan) === 'Grace Period')
    "
    class="org-name-badge"
  >
    <span
      class="arrow-pointer"
      [title]="params?.planExpiration ? 'Plan ' + getTitle(params?.planExpiration, params?.plan) : ''"
      [ngClass]="{
        'public-badge badge-light': getTitle(params?.planExpiration, params?.plan) === 'Active',
        'expired-badge badge-light': getTitle(params?.planExpiration, params?.plan) === 'Expired',
        'warning-badge badge-light': getTitle(params?.planExpiration, params?.plan) === 'Grace Period',
        'default-font': !params?.planExpiration,
      }"
    >
      {{ !params?.planExpiration ? params?.plan : (params?.planExpiration | date: 'MM/dd/yyyy') }}
    </span>
  </span>
</ng-template>
<ng-template #todayQuizModal let-modal>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Today's Quiz Question</h5>
        <div class="justify-content-end default-pointer" (click)="modal.close('Cancel')" title="Close" aria-label="Close" id="closeModalBtn">
          <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 384 512">
            <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
            <path
              fill="var(--grey-text-color)"
              d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
            />
          </svg>
        </div>
      </div>
      <div class="modal-body">
        <div class="question-container">
          <p class="question" [innerHTML]="selectedQuestion?.name"></p>
          <div class="row align-items-center mb-2">
            <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 d-flex align-items-center">
              <div
                id="helpVideoLink"
                type="button"
                class="btn btn-circle btn-success mr-2"
                (click)="openVideoHelp()"
                title="Watch video for help answering this question"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 576 512">
                  <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                  <path
                    fill="#ffffff"
                    d="M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1l0-17.1 0-128 0-17.1 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
                  />
                </svg>
              </div>
              <p class="hint m-0"><i>Hint:</i> {{ selectedQuestion?.hint }}</p>
            </div>
            <app-button
              [hidden]="!getServerAndUserRoleForNextQuiz()"
              title="Next question"
              class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-right"
              for="nextQuestionBtn"
              btnType="primary-solid"
              type="submit"
              id="nextQuestionBtn"
              (click)="goToNextQuestion()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 448 512">
                <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                <path
                  fill="#ffffff"
                  d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                />
              </svg>
            </app-button>
          </div>
          <div class="mt-3 row align-items-center">
            <app-input
              id="userAnswerInput"
              [for]="'userAnswerFC'"
              [placeholder]="'Type your answer here'"
              type="text"
              class="col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9"
              [control]="userAnswerFC"
            ></app-input>
            <app-button
              class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-right"
              btnType="primary-solid"
              [nav]="true"
              title="Check Answer"
              for="checkAnswerBtn"
              (click)="checkAnswer()"
              [disabled]="!userAnswer?.trim()"
              >Check Answer</app-button
            >
          </div>
          <div *ngIf="answerFeedback" class="mt-1">
            <div *ngIf="answerFeedback.correct" class="feedback correct text-success d-flex align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 512 512">
                <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                <path
                  fill="var(--success-color)"
                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                />
              </svg>
              <div class="pt-1 pl-1">Correct</div>
            </div>
            <div *ngIf="!answerFeedback.correct" class="feedback incorrect text-danger d-flex align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 512 512">
                <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                <path
                  fill="var(--danger-color)"
                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                />
              </svg>
              <div class="pt-1 pl-1">Incorrect, please try again</div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer row">
        <a
          href="/dashboard"
          target="_blank"
          class="btn btn-link mr-auto"
          title="This is so you can investigate the answer while keeping the hint open"
          id="openDashboardLink"
        >
          Click here to open the dashboard in a new tab
        </a>
        <app-button
          id="closeBtn"
          class="mr-3"
          title="Close"
          for="cancelBtn"
          [small]="true"
          btnType="primary-outline"
          type="submit"
          (click)="modal.close('Cancel')"
          >Close</app-button
        >
      </div>
    </div>
  </div>
</ng-template>
